import { render, staticRenderFns } from "./TagListTable.vue?vue&type=template&id=823631f8&"
import script from "./TagListTable.vue?vue&type=script&lang=js&"
export * from "./TagListTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1983107846/src/bitbucket.org/atsuboi/chatbot/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('823631f8')) {
      api.createRecord('823631f8', component.options)
    } else {
      api.reload('823631f8', component.options)
    }
    module.hot.accept("./TagListTable.vue?vue&type=template&id=823631f8&", function () {
      api.rerender('823631f8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/TagList/Components/TagListTable.vue"
export default component.exports